module.exports = __webpack_public_path__ + "static/media/rain.289326a4.png";